var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntertainment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.5,
    height: 42.948,
    viewBox: "0 0 43.5 42.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Entertainment",
    transform: "translate(-1012.692 -3182.188)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 41,
    height: 29,
    rx: 2,
    transform: "translate(1013.942 3194.886)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1085",
    "data-name": "Ellipse 1085",
    cx: 7.5,
    cy: 8,
    rx: 7.5,
    ry: 8,
    transform: "translate(1018.942 3201.886)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x2: 12,
    transform: "translate(1037.942 3201.886)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    x2: 12,
    transform: "translate(1037.942 3209.886)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x2: 12,
    transform: "translate(1037.942 3217.886)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x2: 20,
    y2: 11,
    transform: "translate(1025.942 3183.886)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntertainment);
export default __webpack_public_path__ + "static/media/Entertainment.1eadb6d09e11885012ec3fee2386a758.svg";
export { ForwardRef as ReactComponent };